module.exports = __webpack_public_path__ + "static/media/218-Milo-Fragen_ID_2.f83efb43.mp3";